export function assertSyncAPI(condition, apiName) {
    if (process.env.NODE_ENV !== 'production') {
        if (!condition) {
            throw new Error(`Sync '${apiName}' API is not available, make sure to opt-in fe-essentials`);
        }
    }
}
//# sourceMappingURL=assertSyncAPI.js.map